var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUcs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x9D\x90\xE6\xA0\x87\xE7\xB3\xBB 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.73752 12.2875L3.19062 11.2953L0.875 14.6797L4.97187 14.4125L4.41245 13.5817L8.15308 11.4442L7.47815 10.15L3.73752 12.2875Z",
    fill: "#4B4BD1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.82186 11.2953L11.5625 13.4328L11.0281 14.4125L15.125 14.6797L12.8094 11.2953L12.314 12.2026L8.57336 10.0651L7.82186 11.2953Z",
    fill: "#E32B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 1.32031L9.78125 4.97187H8.75146V11.1172H7.29028V4.97187H6.21875L8 1.32031Z",
    fill: "#52D052"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.8297 1.32031H12.6312L11.5625 3.27969V4.4375H10.85V3.27969L9.78125 1.32031H10.5828L11.2063 2.74531L11.8297 1.32031ZM13.0766 10.2266H12.275L13.3438 8.62344L12.3641 7.02031H13.1656L13.7 8.08906L14.3234 7.02031H15.125L14.1453 8.53438L15.125 10.2266H14.3234L13.7 9.15781L13.0766 10.2266ZM0.875 9.69219L2.47812 7.55469H0.875V7.02031H3.27969V7.55469L1.67656 9.69219H3.36875V10.2266H0.875V9.69219Z",
    fill: "#626262"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcs2);
export default __webpack_public_path__ + "static/media/ucs2.204bac02964f3e85eb2276c53029a9f6.svg";
export { ForwardRef as ReactComponent };